import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type QuickMessageRequest = {
  userId: string;
  message: string;
};

@Injectable({
  providedIn: 'root',
})
export class QuickMessageLauncherService {
  private readonly quickMessageRequestsSubject = new Subject<QuickMessageRequest>();
  readonly quickMessageRequests$ = this.quickMessageRequestsSubject.asObservable();

  requestQuickMessage(request: QuickMessageRequest): void {
    const normalizedUserId = request.userId.trim();
    const normalizedMessage = request.message.trim();
    if (!normalizedUserId || !normalizedMessage) {
      return;
    }

    this.quickMessageRequestsSubject.next({
      userId: normalizedUserId,
      message: normalizedMessage,
    });
  }
}
